export function getMoonPhase(date = new Date()) {
  const synodicMonth = 29.530588853
  const knownNewMoon = new Date(Date.UTC(2000, 0, 6, 18, 14)) // Jan 6, 2000

  const daysSince =
    (date.getTime() - knownNewMoon.getTime()) / 86400000

  const phase = (daysSince % synodicMonth + synodicMonth) % synodicMonth

  return {
    age: phase,                         // days since new moon
    percent: (phase / synodicMonth) * 100
  }
}
